module.exports = __webpack_public_path__ + "static/media/bulurah_logo.4776fdb3.png";